// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteTaskPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Task ID"),
});

export const deleteTaskHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Task deleted
 */
export const deleteTask200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteTask401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Task not found
 */
export const deleteTask404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteTaskMutationResponseSchema = z.lazy(() => deleteTask200Schema);
